
const { fetch } = require('whatwg-fetch');
const config = require('../config');
const { state } = require('./state');
const { getAllowCookies } = require('./cookieUtils');


let myRank = { };
myRank.rank = 0;
myRank.score = 0;

function getRank(functionToCall, userId) {

	if (!userId)
		userId = state.userId;

	if (getAllowCookies() && userId) {

		const headers = { 'Accept': 'application/json', 'Content-Type': 'application/json' };
		const body = JSON.stringify({ userId: userId });
		const fetchParams = {
			method: 'POST',
			headers: headers,
			body: body,
		};

		const finishFunction = function(data) {
			myRank = data;
			console.log("userRankResult", data);
			functionToCall(data);
		}

		fetch(`${config.BACKEND_URL}/api/getUserRank`, fetchParams)
			.then(response => response.json())
			.then(finishFunction);
	}
}

module.exports = { getRank };
